import styled from '@emotion/styled';
import { keyframes } from 'emotion';
import React from 'react';

type SpritePlayerProps = {
  url: string;
  spriteSize: { width: number, height: number};
  rows: number;
  columns: number;
  animationDuration: number;
  animationSize?: number;
  animationDelay?: number;
  loop?: boolean;
}

type SpriteContainerProps = {
  containerClassName?: string;
}

type SpriteAnimationProps = SpritePlayerProps & SpriteContainerProps;

const moveOnX = keyframes`
  0% {
    background-position-x: 0px;
  }
  100% {
     background-position-x: calc(var(--sprite-width) * var(--sprites-columns) * -1);
  }
`;

const moveOnY = keyframes`
  0% {
    background-position-y: 0px;
  }
  100% {
     background-position-y: calc(var(--sprite-height) * var(--sprites-rows) * -1);
  }
`;

const displayNone = keyframes`
0% {
  opacity: 1;
}
99% {
  opacity: 1;
}
100% {
    opacity: 0;
  }
`;

const SpritePlayer = styled.div<SpriteAnimationProps>(
  ({ spriteSize, rows, columns, url, animationDuration, animationDelay = 0, loop = true }) => ({
    position: 'absolute',
    top: '50%',
    right: '50%',
    transform: 'translate(50%,-50%)',
    width: spriteSize.width,
    height: spriteSize.height,
    backgroundImage: `url(${url})`,
    backgroundSize: `${spriteSize.width * columns}px  ${spriteSize.height * rows}px`,
    animation: `${moveOnX} ${animationDuration / rows}s steps(${columns}) infinite, 
      ${moveOnY} ${animationDuration}s steps(${rows}) infinite
      ${!loop ? `,${displayNone} ${animationDuration}s forwards` : ''}`,
    animationDelay: `${animationDelay}s`,
  })
);

const SpriteContainer = styled.div({
  height: 200,
  width: 200,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
});

export const testId = 'sprite';

const SpriteAnimation = ({ containerClassName, ...props }: SpriteAnimationProps) => (
  <SpriteContainer
    className={containerClassName}
    data-testid={testId}
  >
    <SpritePlayer
      {...props}
      style={{
        '--sprite-width': `${props.spriteSize.width}px`,
        '--sprite-height': `${props.spriteSize.height}px`,
        '--sprites-columns': props.columns,
        '--sprites-rows': props.rows,
      } as React.CSSProperties}
    />
  </SpriteContainer>
);

export { SpriteAnimation };
